import { useRef } from "react";

import { Section, SectionHeader } from "components/landing/layout/Section";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "components/products/muggleTestV0/components/ui/accordion";
import { FAQ_ITEMS } from "content/landing";
import { trackFaqClick, useSectionViewTracking } from "lib/analytics";

export function FAQSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useSectionViewTracking("faq", sectionRef);

  const handleValueChange = (value: string) => {
    if (!value) return;
    const item = FAQ_ITEMS.find((faq) => faq.id === value);
    if (item) {
      trackFaqClick(item.id, item.question);
    }
  };

  return (
    <Section id="faq" className="bg-background py-3 sm:py-5 lg:py-8">
      <div ref={sectionRef} className="mx-auto max-w-3xl px-4 sm:px-5 lg:px-6">
        <div data-landing-scroll-anchor>
          <SectionHeader
            title="FAQ"
            className="mb-5 sm:mb-6"
            titleClassName="mb-2 text-2xl sm:text-3xl lg:text-4xl"
          />
        </div>

        <Accordion type="single" collapsible className="space-y-2.5" onValueChange={handleValueChange}>
          {FAQ_ITEMS.map((item) => (
            <AccordionItem key={item.id} value={item.id} className="rounded-lg border bg-card px-4">
              <AccordionTrigger className="py-3 text-left text-sm font-medium hover:no-underline sm:text-base">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="pb-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Section>
  );
}
